import email from '../assets/email.png'
import api from '../assets/api.png'
import css from '../assets/css.png'
import figma from '../assets/figma.png'
import flutter from '../assets/flutter.png'
import git from '../assets/git.png'
import graphql from '../assets/graphql.png'
import html from '../assets/html.png'
import javascript from '../assets/javascript.png'
import mu5 from '../assets/mu5.png'
import node from '../assets/node.png'
import python from '../assets/python.png'
import react from '../assets/react.png'
import redux from '../assets/redux.png'
import sass from '../assets/sass.png'
import typescript from '../assets/typescript.png'
import vue from '../assets/vue.png'

import eys from '../assets/eye.png'

import aboutImg from '../assets/aboutImg.svg'

import sabirImg from '../assets/sabir.png'
import LogoSabir from '../assets/logo sabir.png'

import profile from '../assets/profile.png'
import programmer from '../assets/programmer.svg'
import circle from '../assets/circle.svg'

import whatsapp from '../assets/WhatsApp_icon.png'

import youcode from '../assets/youcode.png'
import energidien from '../assets/energedien.png'
import img1337 from '../assets/1337.png'


import gif from '../assets/gif.gif'

const images = {
  eys,
  gif,
  img1337,
  email,
  youcode,
  energidien,
  api,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,

  aboutImg,
  profile,
  programmer,
  circle,

  sabirImg,
  LogoSabir,
  whatsapp
}

export default images
